import { createTheme, Switch } from "@mantine/core";

const theme = createTheme({
  defaultRadius: "sm",
  components: {
    Switch: Switch.extend({
      defaultProps: {
        withThumbIndicator: false,
      },
    }),
  },
});

export default theme;
